import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import '../style/ProjectsSection.scss';
import data from '../data/projects.json';

const ProjectsSection = () => {
  const [projects, setProjects] = useState([]);
  const location = useLocation();

  const isShowcasePage = location.pathname === "/Showcase";

  useEffect(() => {
    const reversed = [...data].reverse();

    if (isShowcasePage) {
      setProjects(reversed); // ALL projects
    } else {
      setProjects(reversed.slice(0, 2)); // latest 2
    }
  }, [isShowcasePage]);

  return (
    <section
      className={`projects ${isShowcasePage ? "projects--showcase" : ""}`}
      aria-labelledby="projects-title"
    >
      <h2 id="projects-title" className="projects__title">Projects We Did</h2>

      <p className="projects__subtitle">
        From Innovative Websites To Customized Digital Solutions...
      </p>

      <div className="projects__list">

        {/* Coming Soon → show on BOTH pages */}
        <article className="projects__card coming-soon">
          <div className="projects__card-link">
            <div className="projects__header">
              <h3>Coming Soon</h3>
            </div>

            <p className="projects__desc">
              Stay tuned for our upcoming exciting projects!
            </p>

            <div className="projects__img">
              <img 
                src="/project/coming-soon.png" 
                alt="Coming Soon" 
                loading="lazy"
              />
            </div>
          </div>
        </article>

        {projects.map((project) => (
          <article className="projects__card" key={project.documentId}>
            {/*<Link 
              to={`/ProjectDetails/${project.documentId}`} 
              className="projects__card-link"
              aria-label={`View details for ${project.title}`}
            >*/}
              <div className="projects__header">
                <h3>{project.title}</h3>
                {project.category && (
                  <span className="projects__tag">{project.category}</span>
                )}
              </div>

              <p className="projects__desc">{project.description}</p>

              {project.gallery?.length > 0 && (
                <div className="projects__img">
                  <img 
                    src={project.gallery[0].url} 
                    alt={project.title} 
                    loading="lazy"
                  />
                </div>
              )}
           {/* </Link>*/}
          </article>
        ))}

      </div>

      {/* See All button → ONLY on Home */}
      {!isShowcasePage && (
        <Link 
          to="/Showcase" 
          className="projects__seeall"
          aria-label="See all projects"
        >
          See All Projects
        </Link>
      )}

    </section>
  );
};

export default ProjectsSection;